import React from 'react';
import { Trophy } from 'lucide-react';
import { RankingComponentProps } from 'types/ranking';
import { getAvatarImage } from 'utils/avatars';
import { getRankingTrophy } from 'utils/trophies';
import './styles.scss';

export function Top5Ranking({ players, title = "Top 5", className = "" }: RankingComponentProps) {
  const top5 = players.slice(0, 5)

  // Função para retornar a cor do troféu baseada na posição
  const getTrophyColor = (position: number) => {
    if (position === 1) return '#FFD700'; // Dourado
    if (position === 2) return '#C0C0C0'; // Prata
    if (position === 3) return '#CD7F32'; // Bronze
    return '#ffffff'; // Branco para 4º e 5º
  };

  return (
    <div className={`top5-ranking ${className}`}>
      {title && <h2 className="ranking-title">{title}</h2>}

      <div className="top5-list">
        {top5.map((player) => {
          const avatarImage = getAvatarImage(player.fotoDePerfil || player.avatar)
          const trophyImageRnk = getRankingTrophy(player.position) // Troféu Rnk para o avatar
          const trophyColor = getTrophyColor(player.position) // Cor do troféu lucide-react

          const salesPercentage =
            player.sales && player.maxSales ? Math.round((player.sales / player.maxSales) * 100) : player.progress || 0

          return (
            <div key={player.id} className="top5-row">
              <div className="player-avatar-container">
                <div className="avatar-wrapper">
                  {avatarImage ? (
                    <img src={avatarImage || "/placeholder.svg"} alt={player.name} className="player-avatar" />
                  ) : (
                    <div className="player-avatar-placeholder">{player.name.charAt(0).toUpperCase()}</div>
                  )}
                  {trophyImageRnk && (
                    <img
                      src={trophyImageRnk || "/placeholder.svg"}
                      alt={`Troféu ${player.position}º lugar`}
                      className="avatar-trophy"
                    />
                  )}
                </div>
              </div>

              <div className="player-info">
                <div className="player-name">{player.name}</div>
                <div className="player-position">
                  <Trophy 
                    className="position-trophy-icon" 
                    size={16} 
                    strokeWidth={2.5}
                    style={{ color: trophyColor }}
                  />
                  <span>{player.position}º Lugar</span>
                </div>
              </div>
              <div className="text-white font-semibold bg-[#8b5cf6] bg-opacity-50 rounded-lg p-2 text-md border border-white/10 drop-shadow-md text-center min-w-[64px]">
                {player.points} PTS
              </div>

              <div className="sales-progress">
                <div className="sales-label">Vendas</div>
                <div className="progress-bar-container">
                  <div className="progress-bar-bg">
                    <div className="progress-bar-fill" style={{ width: `${salesPercentage}%` }}>
                      <span className="progress-percentage">{salesPercentage}%</span>
                    </div>
                  </div>
                  <div className="progress-values">
                    {player.sales && player.maxSales ? `${player.sales}/${player.maxSales}` : `${salesPercentage}/100`}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {top5.length === 0 && <div className="no-data-message">Nenhum dado de ranking disponível</div>}
    </div>
  )
}
